module.exports = __webpack_public_path__ + "media/images/admin/dueldonkey-logo-7436e4af06a2e94e8e3f9ab69dd4661a.svg";